import { useState, useEffect } from 'react'

import { Tooltip } from '@material-ui/core'
import Switch from '@mui/material/Switch'
import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  CheckBox,
  Copy
} from 'components'
import {
  AttachmentFileIcon,
  StatusIcon,
  MagnifyingGlassIcon
} from 'components/Icons'
import { Link } from 'components/Link/Link'
// import { useAuth } from 'hooks'
import useLoading from 'hooks/useLoading'
import { useHistory } from 'react-router-dom'
import { IManageWalletTable } from 'services/NGT/Wallet'
import { COLORS, FORMAT } from 'utils'
interface ITableManageCre {
  tableData: IManageWalletTable[]
  totalItems: number
  page: number
  setPage: (_page: number) => void
  rowsPerPage: number
  setRowsPerPage: (_rowsPerPage: number) => void
  handleSelectItem?: (_row: IManageWalletTable) => void
  handleToWaive?: (_row: IManageWalletTable) => void
  handleCheckAll?: () => void
  isAllChecked?: boolean
  idItens: number[]
  setIdItens: any
  checkPages: boolean
  setCheckAll: (_checkAll: boolean) => void
  checkAll: boolean
  handleNull: () => void
  setCheckPages: (_checkPages: boolean) => void
  handleContractSelection: (
    _contract: number,
    _index: number,
    _unCheckAll?: boolean,
    _idsToExclude?: any[]
  ) => void
  selectedContractInfo: (_contractId: number) => void
}
export const TableManageCre = ({
  tableData,
  totalItems,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  checkAll,
  setCheckAll,
  //handleSelectItem,
  //handleToWaive,
  //handleCheckAll,
  //isAllChecked,
  checkPages,
  setCheckPages,
  handleContractSelection,
  idItens,
  //setIdItens,
  //handleNull,
  selectedContractInfo
}: ITableManageCre) => {
  const history = useHistory()
  //const { user } = useAuth()
  const { setLoading } = useLoading()
  const [, setChecks] = useState([])
  //const [checkAll, setCheckAll] = useState(false)
  const [newRendering, setNewRendering] = useState<IManageWalletTable[]>([])

  const handleChangePage = (newPage: number) => {
    setPage(newPage)
  }

  // const handleCheck = (id) => {
  //   setLoading('loading')
  //   const copyValue = idItens
  //   const index = copyValue.indexOf(id)
  //   if (index != -1) {
  //     const copyArray = copyValue.filter((item) => item != id)
  //     setIdItens(copyArray)
  //   } else {
  //     setIdItens([...idItens, id])
  //   }
  //   setLoading('idle')
  // }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleSetCheck = () => {
    const checksData: { checked: boolean; id: number }[] = tableData.map(
      (item: IManageWalletTable) => {
        return {
          checked: idItens.includes(item.creId),
          id: item.creId
        }
      }
    )
    setChecks(checksData)
  }

  // const handleCheckAll = (e?) => {
  //   const addIds = []
  //   const removeIds = []
  //   tableData.map((item) => {
  //     if (!idItens.includes(item.creId) && !item.codCre) {
  //       addIds.push(item.creId)
  //     } else {
  //       removeIds.push(item.creId)
  //     }
  //   })
  //   if (e) {
  //     setIdItens([...idItens, ...addIds])
  //   } else {
  //     const newArray = idItens.filter((item) => !removeIds.includes(item))
  //     setIdItens(newArray)
  //   }
  // }

  // Código Original
  // const handleClickContract = (obj: IManageWalletTable) => {
  //   history.push({
  //     pathname: '/ngt/analise-cre',
  //     state: {
  //       cdContrato: obj.cdContrato,
  //       dtCompetencia: obj.anoMesCompetencia,
  //       idCreExist: obj.creId,
  //       nmFornecedor: obj.nmFornecedor,
  //       pathBack: '/ngt/carteira-cre',
  //       tab: 2
  //     }
  //   })
  // }

  const handleClickContract = (obj: IManageWalletTable) => {
    const urlParams = new URLSearchParams()
    urlParams.append('cdContrato', obj.cdContrato)
    urlParams.append('dtCompetencia', obj.anoMesCompetencia.toString())
    urlParams.append('idCreExist', obj.creId.toString())
    urlParams.append('nmFornecedor', obj.nmFornecedor)
    urlParams.append('pathBack', '/ngt/carteira-cre')
    urlParams.append('tab', '1')
    urlParams.append('tabBack', '2')

    const baseUrl = `/#/ngt/analise-cre`

    //Criação de nova Aba do Navegador
    window.open(baseUrl, '_blank')

    //OBJ referente ao state da página
    const contratoObj = {
      cdContrato: obj.cdContrato,
      dtCompetencia: obj.anoMesCompetencia,
      idCreExist: obj.creId,
      nmFornecedor: obj.nmFornecedor,
      pathBack: '/ngt/carteira-cre',
      tab: 1,
      tabBack: 2
    }

    localStorage.setItem('dados', JSON.stringify(contratoObj))
  }

  useEffect(() => {
    handleSetCheck()
  }, [page, rowsPerPage, idItens])

  useEffect(() => {
    setNewRendering(tableData)
  }, [tableData])

  useEffect(() => {
    handleSetCheck()
  }, [])

  const pageCheck = () => {
    if (!page || page === 0) return 1
    return page
  }

  const checkAllAction = () => {
    setCheckAll(!checkAll)
    setCheckPages(!checkPages)

    // Realizando check/uncheck dos contratos expostos na página atual
    if (checkAll === false) {
      tableData.map((row: IManageWalletTable, index: number) => {
        row.checked = checkAll
        handleContractSelection(row.creId, index)
      })
    } else {
      const idsToExclude = tableData.map((itens) => itens.creId)
      tableData.map((row: IManageWalletTable, index: number) => {
        row.checked = checkAll
        handleContractSelection(row.creId, index, true, idsToExclude)
      })
    }

    //   // const addIds = []
    //   // const removeIds = []
    //   // tableData.map((item) => {
    //   //   if (!idItens.includes(item.creId) && item.cdContrato && !checkAll) {
    //   //     addIds.push(item.creId)
    //   //   } else {
    //   //     removeIds.push(item.creId)
    //   //   }
    //   // })
    //   // if (checkAll === false) {
    //   //   setIdItens([...idItens, ...addIds])
    //   // } else {
    //   //   const newArray = idItens.filter((item) => !removeIds.includes(item))
    //   //   setIdItens(newArray)
    //   // }
  }

  const INVALID_DATE = '01/01/0001'

  const handleStatus = (status: string, hasItem: boolean) => {
    if (
      status === 'Green' ||
      status === 'Aprovado' ||
      status === 'Liberado' ||
      status === 'L'
    )
      return 'Todos os documentos liberados, após análise'
    if (
      status === 'Yellow' ||
      status === 'Analisar' ||
      status === 'Analisando' ||
      status === 'PendenteDocumento' ||
      status === 'P'
    ) {
      if (hasItem)
        return 'Documento aguardando validação do Analista, em processo de Análise'
      return 'Documentos não anexados pelo Fornecedor'
    }
    return 'Documentos não analisados no Sistema'
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">
                {' '}
                <CheckBox checked={checkAll} onClick={checkAllAction} />{' '}
              </TableCellStyled>
              <TableCellStyled align="left"></TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="center">Código Centro</TableCellStyled>
              <TableCellStyled align="center">Cód.CRE</TableCellStyled>
              <TableCellStyled align="left" minwidth="110px">
                Fornecedor
              </TableCellStyled>
              <TableCellStyled align="center">1ª Mob</TableCellStyled>
              <TableCellStyled align="center">Últ. Mob.</TableCellStyled>
              <TableCellStyled align="center">Denúncia</TableCellStyled>
              <TableCellStyled align="center">Projeto</TableCellStyled>
              <TableCellStyled align="center">Alerta</TableCellStyled>
              <TableCellStyled align="center">SLA</TableCellStyled>
              <TableCellStyled align="center">Data Anexo</TableCellStyled>
              <TableCellStyled align="center">Data Análise</TableCellStyled>
              <TableCellStyled align="center">Últ. Análise</TableCellStyled>
              <TableCellStyled align="center">Valor Folha</TableCellStyled>
              <TableCellStyled align="center">Efetivos</TableCellStyled>
              <TableCellStyled align="center">Analista</TableCellStyled>
              <TableCellStyled align="center">Status</TableCellStyled>
              <TableCellStyled align="center">Ativo</TableCellStyled>
              <TableCellStyled align="center">Ação</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {newRendering.length > 0 &&
              newRendering.map((row: IManageWalletTable, index: number) => (
                <TableRowStyled
                  style={{
                    background: row.slaVencido ? 'rgba(175, 39, 47, .2)' : null
                  }}
                  key={`${index}-${row.contratoId}`}
                >
                  <TableCellStyled align="left">
                    <CheckBox
                      checked={row.checked}
                      onClick={() => handleContractSelection(row.creId, index)}
                      disabled={row.creDisponivel === false ? true : false}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    <Copy
                      title="Copiar código de contrato"
                      valueToCopy={row.cdContrato}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="left">
                    {
                      <Link
                        onClick={() => selectedContractInfo(row.contratoId)}
                        color={COLORS.blueFonts}
                      >
                        {row.cdContrato || '-----'}
                      </Link>
                    }
                  </TableCellStyled>
                  <TableCellStyled align="center">{row.cdCentro || '-----'}</TableCellStyled>
                  <TableCellStyled align="center">
                    {row.codCre || '-----'}
                  </TableCellStyled>

                  <TableCellStyled align="left">
                    {row.nmFornecedor || '-----'}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    <Switch checked={row.flPrimeiraMob} />
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    <Switch checked={row.flUltMedicao} />
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    <Switch checked={row.flDenuncia} />
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    <Switch checked={row.flProjeto} />
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    <Switch checked={row.flAlerta} />
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {row.vlSla === null ? '---' : row.vlSla}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {' '}
                    {FORMAT.formatDDMMYYYY(row.dtAnexo)}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {' '}
                    {FORMAT.formatDDMMYYYY(row.dtAnalise)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {' '}
                    {FORMAT.formatDDMMYYYY(row.dtUltAnaliseCRE)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.vlFolhaPagto
                      .toLocaleString('pt-BR', {
                        currency: 'BRL',
                        style: 'currency'
                      })
                      .toString()}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {row.qtTotalEfetivo ? row.qtTotalEfetivo : '-----'}
                    {/* {row.qtTotalEfetivo ? (
                      row.creDisponivel === true ? (
                        <Link
                          onClick={
                            row.creDisponivel
                              ? () => {
                                  handleClickContract(row)
                                }
                              : null
                          }
                        >
                          {' '}
                          {row.qtTotalEfetivo}
                        </Link>
                      ) : (
                        row.qtTotalEfetivo
                      )
                    ) : row.creDisponivel === true ? (
                      <Link
                        onClick={
                          row.creDisponivel
                            ? () => {
                                handleClickContract(row)
                              }
                            : null
                        }
                      >
                        {' '}
                        {row.qtTotalEfetivo}
                      </Link>
                    ) : (
                      row.qtTotalEfetivo
                    )} */}
                  </TableCellStyled>

                  <TableCellStyled align="center">
                    {row.nmAnalista ? row.nmAnalista : '------'}
                    {/* {row.nmAnalista ? (
                      row.creDisponivel === true ? (
                        <Link
                          onClick={
                            row.creDisponivel
                              ? () => {
                                  handleClickContract(row)
                                }
                              : null
                          }
                        >
                          {' '}
                          {row.nmAnalista}
                        </Link>
                      ) : (
                        row.nmAnalista
                      )
                    ) : row.creDisponivel === true ? (
                      <Link
                        onClick={
                          row.creDisponivel
                            ? () => {
                                handleClickContract(row)
                              }
                            : null
                        }
                      >
                        {' '}
                        {'---'}
                      </Link>
                    ) : (
                      '------'
                    )} */}
                  </TableCellStyled>

                  <Tooltip
                    arrow
                    placement="left"
                    title={handleStatus(row.txStatusColor, row.hasItem)}
                  >
                    <TableCellStyled align="center">
                      <StatusIcon value={row.txStatusColor} marginLeft="20px" />
                    </TableCellStyled>
                  </Tooltip>
                  <TableCellStyled align="center" style={{ paddingLeft: '0.8rem' }}>
                    <AttachmentFileIcon
                      colorIcon={row.hasItem ? COLORS.black : COLORS.lightGray}
                    />
                  </TableCellStyled>
                  <TableCellStyled align="center" style={{ paddingLeft: '0.8rem' }}>
                    {row.creDisponivel === true ? (
                      <Link onClick={() => handleClickContract(row)}>
                        <MagnifyingGlassIcon
                          style={{ justifyContent: 'left' }}
                        />
                      </Link>
                    ) : (
                      <MagnifyingGlassIcon
                        style={{ justifyContent: 'left' }}
                        disabled={true}
                      />
                    )}
                  </TableCellStyled>
                </TableRowStyled>
              ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={pageCheck()}
        rows={tableData}
        totalItems={totalItems}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  )
}

//
